(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/single-rows/single-board.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/single-rows/single-board.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.SingleBoard = Backbone.Marionette.View.extend({
    log: new svs.core.log.Logger('svs.tipset.views.SingleBoard'),
    ui: {
      boardWrapper: '.board-wrapper',
      clearSingleBoard: '.single-clear-board-button'
    },
    events: {
      'click @ui.boardWrapper': 'clickBoard',
      'click @ui.clearSingleBoard': 'clearBoard'
    },
    defaults: {
      okToMark: false
    },
    modelEvents: {
      change: 'render'
    },
    className: 'board-wrapper-outer js-slider-slide slider-slide',
    template: function(data) {
      return svs.tipset.templates.single_board(data);
    },
    onRender: function() {
      this.$el.toggleClass(
        'single-rows-complete-board',
        this.model.get('isCompleteBoard')
      );
      this.$el.toggleClass(
        'single-rows-active-board',
        this.model.get('isActiveBoard')
      );
    },
    clickBoard: function(ev) {
      this.model.setBoardData(
        parseInt(
          $(ev.target)
            .parent()
            .attr('data-row'),
          10
        ),
        parseInt(
          $(ev.target)
            .parent()
            .attr('data-mark'),
          10
        )
      );
    },
    clearBoard: function() {
      this.model.clearBoardData();
    }
  });
})(Backbone, _, svs);

 })(window);